const repairDate = () => import('@/pages/repairDate')
const repairDateIndex = () => import('@/pages/repairDateIndex')
const repairDateList = () => import('@/pages/repairDateList')
const createRepairDate = () => import('@/pages/createRepairDate')
const writeDate = () => import('@/pages/writeDate')

export default [{
  path: '/createRepairDate',
  name: 'createRepairDate',
  component: createRepairDate,
  meta: {}
},
{
  path: '/writeDate',
  name: 'writeDate',
  component: writeDate,
  meta: {}
},
{
  path: '/repairDateIndex',
  name: 'repairDateIndex',
  component: repairDateIndex,
  meta: {
    storeKey: 'trs.repairDate.index'
  }
},
{
  path: '/repairDateList',
  name: 'repairDateList',
  component: repairDateList,
  meta: {}
},
{
  path: '/repairDate',
  name: 'repairDate',
  component: repairDate,
  meta: {}
}
]



// WEBPACK FOOTER //
// ./src/router/repairDate/index.js